<template id="trafficDiffLineChart">
  <div ref="container" :style="{'height':'calc(80% - 25px)','width':width,'position': 'absolute','display': 'flex'}"></div>
</template>

<script type="text/javascript" src="https://cdn.jsdelivr.net/npm/echarts@5.3.2/dist/echarts.min.js"></script>

<script>
import * as echarts from 'echarts';

export default {
  name: "TrafficDiffLineChart",
  data() {
    return {
      timeIntervalCode: '5m',
      timer: false,

    }
  },
  props: {
    total: {},
    max: {},
    min: {},
    avg: {},
    tras: {},
    dataTimes: {},
    gatewayCodeProps:{
      type:String,
      default:''
    },
    width: {
      type: String,
      default: '100%'
    }
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.dispose()
      this.myChart = undefined
    }
  },
  mounted() {
    this.$nextTick(() => this.initEcharts())
  },
  methods: {
    reload(){
      this.$nextTick()
      this.setOption()
    },
    initEcharts() {
      this.myChart = echarts.init(this.$refs.container);
      this.myChart.setOption({
        title: {
          left: '6%',
          text: '历史流量折线图',

        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 30
          },
          {
            height: 20,
            start: 0,
            end: 100
          }
        ],
        legend: {
          left: '30%',
          type: "scroll",
        },
        graphic: [
          {
            type: 'text',
            left: '6.2%',
            top: '30px',
            style: {
              text: '总流量：' + this.total + '(Mbps)  最大值：' + this.max + '(Mbps)  最小值：' + this.min + '(Mbps)  平均值：' + this.avg + '(Mbps)',
              textAlign: 'right',
              fontSize: this.transformFontSize(15),
              fontWeight: 550
            }
          },
        ],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            animation: false
          }
        },

        xAxis: {
          type: 'category',
          boundaryGap: false,
          symbolSize: 10,
          data: this.dataTimes
        },
        yAxis: {

          type: 'value',
          axisLabel: {
            formatter: '{value} Mbps',
            top : '10px'
          },

        },
        series: [
          {
            name: '历史流量',
            data: this.tras,
            type: 'line',
            smooth: true,

          }
        ]
      }, true)
      this.myChart.resize()
    },

  // 根据不同的屏幕宽度换算字体大小
  transformFontSize(fontsize) {
    // 获取屏幕宽度
    const width = window.screen.width
    const ratio = width / 1920
    // 取下整
    return parseInt(fontsize * ratio)
  },
    setOption() {
      this.myChart.setOption({
        graphic: [
          {
            style: {
              text: '总流量：' + this.total + '(Mbps)  最大值：' + this.max + '(Mbps)  最小值：' + this.min + '(Mbps)  平均值：' + this.avg + '(Mbps)',
            }
          },
        ],
        xAxis: {
          data: this.dataTimes
        },
        series: [
          {
            data: this.tras
          }
        ]
      })
      this.myChart.resize()
    }
  },
  watch: {
    tras() {
      this.setOption()
    },
  }
}
</script>

<style scoped>

</style>